'use client';

import type { ProductDetailData } from '@eliadmin/core/src/api/products/types/product-types';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

import { cn } from '@eliadmin/core/src/utils/style-utils';

export function ProductAttributes({ product }: { product: ProductDetailData }) {
  const { t } = useTranslations();

  return (
    <div className={cn('flex flex-col items-start justify-start gap-6')}>
      <h2 className="h5 font-semibold uppercase text-black">{t('text9')}</h2>
      <div className="flex w-full flex-col items-start justify-start">
        {product.attributes?.map((attribute, index) => (
          <div
            key={attribute.name}
            className={cn('grid w-full grid-cols-2', {
              'bg-neutral-100': index % 2 !== 0,
            })}
          >
            <p className="col-span-1 flex w-full items-center justify-start p-4 font-bold uppercase">
              {attribute.name}:
            </p>
            <p className="col-span-1 flex w-full items-center justify-start p-4">
              {attribute.values?.[0]?.name}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
